function getAnnualReportYearService() {
    return (new Date().getFullYear() - 1).toString();
}

export default getAnnualReportYearService;